import React from "react";

import "./styles/DashboardNavBarResultados.scss";
const DashboardNavBarResultados = (props) => {

  return (
    <div className="header-navBar">
      <div className="navBar-container">
        <div className="flex align-items-center justify-content-between w-full">
          {props.titulo && <div className="title">{props.titulo}</div>}
          {props.adicionalNota && props.adicionalNota}
        </div>
      </div>
    </div>
  );
};

export default DashboardNavBarResultados;
